// extracted by mini-css-extract-plugin
export var wrap = "textAnimator-module--wrap--SI2E+";
export var item = "textAnimator-module--item--xc1tu";